import memoizeOne from "memoize-one";

import { IPickerListItem } from "@livechat/design-system-react-components";

import {
  CustomDateRangeFilterId,
  DateRangeFilterFormattedValues,
  IDateRangeWithCompareFilter,
} from "constants/filters";

import { ICustomRangeDatePickerOption, PickerType } from "./interfaces";

export const dateRangeOptions: ICustomRangeDatePickerOption[] = [
  {
    id: CustomDateRangeFilterId.Today,
    label: DateRangeFilterFormattedValues[CustomDateRangeFilterId.Today],
    // @ts-expect-error TS(2322)
    value: { from: null, to: null },
    relativeValue: {
      from: "-0D",
    },
  },
  {
    id: CustomDateRangeFilterId.Yesterday,
    label: DateRangeFilterFormattedValues[CustomDateRangeFilterId.Yesterday],
    // @ts-expect-error TS(2322)
    value: { from: null, to: null },
    relativeValue: {
      from: "-1D",
      to: "-0D",
    },
  },
  {
    id: CustomDateRangeFilterId.Last7Days,
    label: DateRangeFilterFormattedValues[CustomDateRangeFilterId.Last7Days],
    // @ts-expect-error TS(2322)
    value: { from: null, to: null },
    relativeValue: {
      from: "-6D",
    },
  },
  {
    id: CustomDateRangeFilterId.LastMonth,
    label: DateRangeFilterFormattedValues[CustomDateRangeFilterId.LastMonth],
    // @ts-expect-error TS(2322)
    value: { from: null, to: null },
    relativeValue: {
      from: "-1M",
      to: "-0M",
    },
  },
  {
    id: CustomDateRangeFilterId.CustomPeriod,
    pickerType: PickerType.Date,
    label: DateRangeFilterFormattedValues[CustomDateRangeFilterId.CustomPeriod],
    // @ts-expect-error TS(2322)
    value: { from: undefined, to: undefined },
  },
  {
    id: CustomDateRangeFilterId.CustomTime,
    pickerType: PickerType.Time,
    label: DateRangeFilterFormattedValues[CustomDateRangeFilterId.CustomTime],
    // @ts-expect-error TS(2322)
    value: { from: undefined, to: undefined },
  },
];

const calculateItems = memoizeOne((options: ICustomRangeDatePickerOption[]) =>
  options.map(option => ({
    key: option.id,
    name: option.label || "",
  }))
);

export function getItems(skipCustomPeriodOption?: boolean): IPickerListItem[] {
  if (skipCustomPeriodOption) {
    return calculateItems(dateRangeOptions.filter(item => item.id !== CustomDateRangeFilterId.CustomTime));
  }
  return calculateItems(dateRangeOptions);
}

export function isCustomPeriodOptionSelected(filterValues: IDateRangeWithCompareFilter): boolean {
  return (
    filterValues &&
    (filterValues.id === CustomDateRangeFilterId.CustomPeriod || filterValues.id === CustomDateRangeFilterId.CustomTime)
  );
}
